// coordinates.js
import { PDFDocument } from 'pdf-lib';
const supplierCoordinates = {
    "British Gas": {
        1: {
            signature: { xPercent: 0.60, yPercent: 0.255, widthPercent: 0.2, heightPercent: 0.035 },
            signingDate: { xPercent: 0.60, yPercent: 0.24 },
        },
        // 2: {
        //     signature: { xPercent: 0.70, yPercent: 0.15, widthPercent: 0.2, heightPercent: 0.075 },
        //     userName: { xPercent: 0.70, yPercent: 0.135 },
        //     jobTitle: { xPercent: 0.70, yPercent: 0.112 },
        //     signingDate: { xPercent: 0.70, yPercent: 0.09 },
        // },
        // 3: {
        //     signature: { xPercent: 0.70, yPercent: 0.15, widthPercent: 0.2, heightPercent: 0.075 },
        //     userName: { xPercent: 0.70, yPercent: 0.135 },
        //     jobTitle: { xPercent: 0.70, yPercent: 0.112 },
        //     signingDate: { xPercent: 0.70, yPercent: 0.09 },
        // }
    },
    "British Gas Lite": {
        1: {
            signature: { xPercent: 0.67, yPercent: 0.068, widthPercent: 0.2, heightPercent: 0.035 },
            signingDate: { xPercent: 0.7, yPercent: 0.02 },
        }
    },
    "Smartest Energy": {
        1: {
            signature: { xPercent: 0.15, yPercent: 0.08, widthPercent: 0.2, heightPercent: 0.038 },
            signingDate: { xPercent: 0.65, yPercent: 0.095 },
        },
        2: {
            signature: { xPercent: 0.58, yPercent: 0.458, widthPercent: 0.18, heightPercent: 0.035 },
            signingDate: { xPercent: 0.62, yPercent: 0.412 },
        }
    },
    "Scottish Power": {
        2: {
            signature: { xPercent: 0.165, yPercent: 0.39, widthPercent: 0.2, heightPercent: 0.05 },
            signingDate: { xPercent: 0.5, yPercent: 0.415 },
        },
        3: {
            signature: { xPercent: 0.07, yPercent: 0.035, widthPercent: 0.2, heightPercent: 0.04 },
            signingDate: { xPercent: 0.278, yPercent: 0.052 },
        }
    },
    "E-ON Next": {
        2: {
            signature: { xPercent: 0.1, yPercent: 0.539, widthPercent: 0.2, heightPercent: 0.04 },
            signingDate: { xPercent: 0.62, yPercent: 0.517 },
        }
    },
    "EDF Energy": {
        2: [
            {
                signature: { xPercent: 0.1, yPercent: 0.539, widthPercent: 0.2, heightPercent: 0.04 },
                signingDate: { xPercent: 0.62, yPercent: 0.517 },
            },
            {
                signature: { xPercent: 0.1, yPercent: 0.197, widthPercent: 0.2, heightPercent: 0.04 },
                signingDate: { xPercent: 0.83, yPercent: 0.21 },
            }
        ]
    },
    "Scottish And Southern": {
        1: {
            signature: { xPercent: 0.3, yPercent: 0.19, widthPercent: 0.2, heightPercent: 0.038 },
            signingDate: { xPercent: 0.7, yPercent: 0.196 },
        },
        3: {
            signature: { xPercent: 0.6, yPercent: 0.448, widthPercent: 0.2, heightPercent: 0.035 },
            signingDate: { xPercent: 0.63, yPercent: 0.415 },
        }
    },
    // "Clear Business": {
    //     1: {
    //         signature: { xPercent: 0.3, yPercent: 0.19, widthPercent: 0.2, heightPercent: 0.04 },
    //         signingDate: { xPercent: 0.7, yPercent: 0.196 },
    //     }
    // },
    // "Utilita": {
    //     5: {
    //         signature: { xPercent: 0.64, yPercent: 0.816, widthPercent: 0.2, heightPercent: 0.028 },
    //         signingDate: { xPercent: 0.631, yPercent: 0.78 },
    //     }
    // }
};
export const getCoordinatesBySupplier = (supplierName) => {
    return supplierCoordinates[supplierName] || null;
};
export const getCoordinatesForLOA = () => {
    return {
        1: {
            signature: { xPercent: 0.205, yPercent: 0.1, widthPercent: 0.2, heightPercent: 0.05 },
            signingDate: { xPercent: 0.71, yPercent: 0.12 },
        }
    }
}
// Function to split merged PDF
export const splitMergedPDF = async (signedMergedPdfBuffer) => {
    // Load the signed merged PDF
    const signedPdfDoc = await PDFDocument.load(signedMergedPdfBuffer);
    const totalPages = signedPdfDoc.getPageCount(); // Total pages in merged PDF
    const secondLastPageIndex = totalPages - 2; // Index of the second last page
    const firstPdfPageCount = totalPages - 2; // All pages except the last two
    // :white_tick: Extract first PDF (first `n` pages excluding last two)
    const firstPdfDoc = await PDFDocument.create();
    for (let i = 0; i < firstPdfPageCount; i++) {
        const [copiedPage] = await firstPdfDoc.copyPages(signedPdfDoc, [i]);
        firstPdfDoc.addPage(copiedPage);
    }
    const firstPdfBytes = await firstPdfDoc.save(); // Convert to bytes
    // :white_tick: Extract second last page as second PDF
    const secondPdfDoc = await PDFDocument.create();
    const [secondLastPage] = await secondPdfDoc.copyPages(signedPdfDoc, [secondLastPageIndex]);
    secondPdfDoc.addPage(secondLastPage);
    const secondPdfBytes = await secondPdfDoc.save(); // Convert to bytes
    return {
        firstPdfBytes,
        secondPdfBytes
    };
};





